import React from "react";
import { Select } from "Components/Base/Inputs/Select";
import { MenuItem } from "Components/Base/Inputs/MenuItem";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { FormControl } from "Components/Base/Inputs/FormControl";

/**
 * @deprecated
 * This SelectFilter component is deprecated.
 * Please use the FormControlSelect component instead:
 * \Components\Fragment\Inputs\FormControlSelect\index.jsx
 */

const SelectFilter = ({
  name,
  options,
  value,
  onChange,
  className = "",
  fullWidth = false,
  displayLabel = true,
  sx,
  languageContext,
  translateOptions = false,
}) => {
  return (
    <FormControl
      className={`filter-select ${className}`}
      fullWidth={fullWidth}
      sx={sx}
    >
      <InputLabel
        id={`${name}-label`}
        className={`${!displayLabel ? "sr-only" : ""}`}
      >
        {name}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        title={`${name}`}
        id={name}
        name={name}
        value={value || 0}
        onChange={(e) => onChange(e.target.value)}
        className={className}
        label={name}
        displayEmpty
        autoWidth
        sx={sx}
      >
        {options.map((option) => (
          <MenuItem key={`SctF_${option.value}`} value={option.value}>
            {translateOptions ? languageContext(option.label) : option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectFilter;
